import { z } from 'zod';

// Allowed special characters: ! @ # $ % ^ & * ( ) _ + - = { } [ ] : ; " ' < > , . ? / | \ ~ `
const SPECIAL = /[!@#$%^&*()\-_+={}\[\]:;"'<>,.?\/|\\~`]/;
const ALLOWED = /^[A-Za-z\d!@#$%^&*()\-_+={}\[\]:;"'<>,.?\/|\\~`]+$/;

export const PasswordSchema = z
  .string()
  .nonempty('Password is required')
  .min(8, 'Password must be at least 8 characters long')
  .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .regex(/[a-z]/, 'Password must contain at least one lowercase letter')
  .regex(/[0-9]/, 'Password must contain at least one number')
  .regex(SPECIAL, 'Password must contain at least one special character (e.g. @, #, $, !)')
  .regex(ALLOWED, 'Password contains an unsupported character');


export const UserEmailSchema = z
  .string()
  .trim()
  .nonempty('Email address is required')
  .email('Invalid email address');